import React from "react";
import ReactDom from "react-dom";
import App from './App'
import './css/bootstrap.min.css'

ReactDom.render(<App/>, document.getElementById('root'))